import { TUrlParam } from "types/utils";

export enum EAdvertisementsQueryKeys {
  getAdvertisements = "getAdvertisements",
  getAdminAdvertisements = "getAdminAdvertisements",
  createAdvertisement = "createAdvertisement",
  deleteAdvertisement = "deleteAdvertisement",
}

export const ADVERTISEMENTS_ENDPOINTS = {
  ROOT: "/advertisements",
  ADMIN_ROOT: "/admin/advertisements",
  ADMIN_ID: (id: TUrlParam) => `/admin/advertisements/${id}`,
};
